import { DynamicObjectInterface } from '../../sdk/type';

/**
 * This function is used to get the translated message for a given key.
 * @param translation - The translation function from react-i18next
 * @param key - The key for the translation
 * @param data - The data to replace in the translation string
 * @param type - The type of message (success or error) [error|success]
 * @returns - The translated message
 */
export const getTranslatedMessage = (
  translation: Function,
  key: string,
  data: Record<string, DynamicObjectInterface> = {},
  type: string = 'error',
) => {
  const defaultMessage =
    type === 'success'
      ? translation('dashboard.api-message.default.success')
      : translation('dashboard.api-message.default.error');

  const _message = defaultMessage;

  if (data) return replacePlaceholders(translation(key, { defaultValue: _message }), data);
  else return translation(key, { defaultValue: _message });
};

/**
 * Replaces {key} in a string with values from data.
 *
 * @param template - A string like "{name} joined {teamName}"
 * @param data - An object like { name: "Ali", teamName: "Red Team" }
 */
export function replacePlaceholders(template: string, data: Record<string, DynamicObjectInterface> = {}): string {
  return template.replace(/{(\w+)}/g, (_, key) => {
    return data[key] !== undefined ? data[key] : `{${key}}`;
  });
}
